import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  cardBackground: {
    position: 'absolute',
    padding: 24,
    zIndex: 100000,
    bottom: 0,
    right: 0,
    left: 0,
    top: 0,
    boxSizing: 'border-box'
  },
  card: {
    width: '50%',
    minHeight: '12.5rem',
    position: 'absolute',
    top: '14%',
    left: '25%',
    backgroundColor: theme.vars.palette.background.default
  },
  cardHeader: {
    borderBottom: `1px solid ${theme.vars.palette.divider}`,
    fontWeight: 600,
    padding: '0.5rem 1rem',
    minHeight: '3rem'
  },
  cardText: {
    fontSize: '1.2rem',
    marginTop: '0.75rem'
  },
  checkBoxText: {
    fontSize: '1rem',
    display: 'inline',
    color: theme.vars.palette.text.secondary
  },
  clickHereText: {
    color: theme.vars.palette.primary.main,
    textDecoration: 'none'
  }
}));

export default useStyles;
